import { lazy } from 'react';

const BuilderPage = lazy(() => import('./pages/BuilderPage'));
const BlocksLibraryPage = lazy(() => import('./pages/BlocksLibraryPage'));

export const muiBuilderRoutes = {
  path: 'mui-builder',
  children: [
    { element: <BlocksLibraryPage />, index: true },
    { path: 'blocks', element: <BlocksLibraryPage /> },
    { path: 'new', element: <BuilderPage /> },
    { path: ':blockId', element: <BuilderPage /> },
  ],
};
